import * as Helper from '../../weave/helpers.mjs';

class FurnitureIndex {
    constructor(form) {
        this.form = form;
        this.page = 1;
        this.container = document.getElementById("searchItems");

        this.loading = false;

        this.updateSortOrderIcon();

        $('#fullLoadOverlay').stop().fadeIn('fast');
        $('#fullLoaderSpacer').stop().fadeIn('fast');
        
        var _this = this;

        $('body').on('click',".hasModal h5", function(e) {
            $('.filterModal.open').not($(this).next()).siblings('h5').children('i').toggleClass('open');
            _this.toggleVal($('.filterModal.open').not($(this).next()).siblings('.sectionOpen'));
            $('.filterModal.open').not($(this).next()).removeClass('open');
            $(this).find('i').toggleClass('open');
            $(this).next('.filterModal').toggleClass('open');
            _this.toggleVal($(this).siblings('.sectionOpen'))
        });

        $('body').on('click',".hasChildren .filterItemContainer", function(e) {
            if (!$(e.target).hasClass('.checkMarkContainer')) {
                $(this).find('i').toggleClass('fa-chevron-up fa-chevron-down');
                _this.toggleVal($(this).children(".subCatOpenFlag"));
                $(this).siblings('ul').toggleClass('open');
            }
        });

        $('body').on('click',".closeModal", function() {
            $(this).parent('.filterModal').removeClass('open');
            $(this).parent('.filterModal').siblings(".sectionOpen").val(0);
            $(this).parents('.filterSection').find('i').toggleClass('open');
        });

        $('body').on('click',".filterItemContainer", function(e) {
            var $li = $(this).parent("li");
            if ($li.length && $li.hasClass('hasChildren')) {
                return;
            }

            var $c = $(this).find('.checkMarkInput');

            if ($c.length) {
                var c = $c[0];
                c.checked = c.checked ? false : true;
            }
        });

        $('body').on('click', '.filterTag.removable', this.removeFilter.bind(this));

        $('body').on('click', '.sortOrder', this.changeSortOrder.bind(this));

        document.querySelectorAll(".filterApply").forEach(f => {
            f.addEventListener('click', this.onFilter.bind(this));
        });

        document.getElementById("orderby").addEventListener('change', this.onFilter.bind(this));
        document.getElementById("sortOrderInput").addEventListener('change', this.onFilter.bind(this));

        this.loadList();
    }

    changeSortOrder(e) {
        const input = document.getElementById("sortOrderInput");
        if (input.value == 'asc') {
            $('.sortOrder.asc').removeClass("asc").addClass("desc");
            $('.sortOrder i.asc').hide();
            $('.sortOrder i.desc').show();
            input.value = 'desc';
        } else {
            $('.sortOrder.desc').removeClass("desc").addClass("asc");
            $('.sortOrder i.asc').show();
            $('.sortOrder i.desc').hide();
            input.value = 'asc';
        }

        this.onFilter();
    }

    removeFilter(e) {
        var $tag = (e.target.tagName == 'I') ? $(e.target).parent() : $(e.target);
        var filterItem = $tag.attr('filter');
        var filterCat = $tag.attr('parent');
        var $input = $('body').find('[category="'+filterCat+'"]').find('[item="'+filterItem+'"]');

        if ($input.hasClass("rangeInput")) {
            $input.attr('disabled', 'disabled');
            $input.parents(".sliderItem").addClass("sliderOff");
            $input.parents(".sliderItem").removeClass("sliderOn");
        } else if (filterCat == 'search') {
            $input[0].value = "";
        } else {
            $input[0].checked = false;
        }

        $tag.remove();
        this.onFilter();
    }

    toggleVal(e){
        if (e.val() == 1) {
            e.val(0);
        } else {
            e.val(1);
        }
    }

    updateSortOrderIcon() {
        const orderby = document.getElementById('orderby');
        const dir = document.getElementById("sortOrderInput");
        if (orderby.value == 'name') {
            $('.sortOrder .numeric').hide();
            $('.sortOrder .alpha.'+dir.value).show();
        } else {
            $('.sortOrder .numeric.'+dir.value).show();
            $('.sortOrder .alpha').hide();
        }
    }

    onFilter() {
        this.updateSortOrderIcon();
        $('.filterModal').removeClass('open');
        $('.filterModal').siblings(".sectionOpen").val(0);
        $('.filterSection').find('i.open').removeClass('open');
        this.container.innerHTML = '';
        this.page = 1;
        $('#listLoadOverlay').stop().fadeIn('fast');
        this.loadList();
    }

    loadList() {
        var formData = new FormData(this.form);
        var url = '/furniture/list';

        formData.append('page', this.page);

        this.loading = true;

        fetch(url, {
            body: formData,
            method: 'POST'
        }).then(response => {
            return response.text();
        }).then(text => {
            let doc = new DOMParser().parseFromString(text, "text/html");
            var newFilterTags = doc.getElementById("newFilterTags");
            var formValues = doc.getElementById("formValues");
            var mainFormValues = document.getElementById("formValues");
            mainFormValues.innerHTML = formValues.innerHTML;
            // $(newFilterTags).remove();
            document.getElementById('filterTags').innerHTML = newFilterTags.innerHTML;
            this.stopLoading();
            var resultsCount = $('#indexResults').val();
            $('#resultsCount').text(resultsCount+" result"+(resultsCount != 1 ? "s" : ""));
            if (this.container.innerHTML == "" || document.getElementById("latestResults").value > 0) {
                this.container.innerHTML += doc.getElementById("results").innerHTML;
            }

            let path = window.location.pathname.split("/");
            if (path[2] === 'search') {
                history.replaceState("", "", "/furniture/search?q=" + $('#encodedUrl').val());
            }
            window.addEventListener("scroll", this.onScroll.bind(this));
            // $('.productContainer').fadeIn();
        }).catch(r => {
            Helper.notifyError("Sorry, an error occurred while loading search results");
            this.stopLoading();
        });
    }

    stopLoading() {
        $('#fullLoadOverlay').stop().fadeOut('fast');
        $('#fullLoaderSpacer').stop().fadeOut('fast');
        $('#listLoadOverlay').stop().fadeOut('fast');
        this.loading = false;
    }

    reload() {
        this.page++;
        var pages = document.getElementById("pages");
        if (pages && this.page > pages.value) {
            return;
        }
        $('#listLoadOverlay').stop().fadeIn('fast');
        this.loadList();
    }

    onScroll() {
        var footerHeight = document.getElementById("footer").offsetHeight,
        height = document.documentElement.offsetHeight,
        // Get the current offset - how far "scrolled down"
        offset = document.documentElement.scrollTop + window.innerHeight;

        // Check if user has hit the end of page
        if (offset >= (height - footerHeight) && !this.loading) {
            this.reload();
        }
    }
}

export { FurnitureIndex };